module.exports = __webpack_public_path__ + "img/bar-bg.19106a27.png";